module.exports = __webpack_public_path__ + "static/img/tum-logo.8f280ce4.png";